var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheapest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5556 4.55556C10.5556 5.41467 8.64033 6.11111 6.27778 6.11111C3.91523 6.11111 2 5.41467 2 4.55556M10.5556 4.55556C10.5556 3.69645 8.64033 3 6.27778 3C3.91523 3 2 3.69645 2 4.55556M10.5556 4.55556V5.72222M2 4.55556V13.8889C2 14.748 3.91523 15.4444 6.27778 15.4444M6.27778 9.22222C6.14669 9.22222 6.01697 9.22008 5.88889 9.21588C3.70858 9.14443 2 8.47811 2 7.66667M6.27778 12.3333C3.91523 12.3333 2 11.6369 2 10.7778M17.5556 9.61111C17.5556 10.4702 15.6403 11.1667 13.2778 11.1667C10.9152 11.1667 9 10.4702 9 9.61111M17.5556 9.61111C17.5556 8.752 15.6403 8.05556 13.2778 8.05556C10.9152 8.05556 9 8.752 9 9.61111M17.5556 9.61111V15.4444C17.5556 16.3036 15.6403 17 13.2778 17C10.9152 17 9 16.3036 9 15.4444V9.61111M17.5556 12.5278C17.5556 13.3869 15.6403 14.0833 13.2778 14.0833C10.9152 14.0833 9 13.3869 9 12.5278",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheapest);
export default __webpack_public_path__ + "static/media/cheapest.a927acd21eb29557e8fed634ee9f5946.svg";
export { ForwardRef as ReactComponent };